module.exports = __webpack_public_path__ + "img/twitter.37caa662.svg";